<style>
    .wrapperx {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }

    .m-form .m-form__group:first-child {
        padding-top: 15px;
    }

</style>

<template>
    <form method="POST" class="m-form m-form--state" id="myForm" v-on:submit.prevent="save">
        <div class="row m-portlet__body">
            <div class="col-md-6">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('name')}">
                    <label>
                        {{$t('Name')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="role.name">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('name')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group m-form__group" v-bind:class="{'has-danger': hasError('description')}">
                    <label>
                        {{$t('Description')}}
                    </label>
                    <input type="text" class="form-control m-input" v-model="role.description">
                    <div class="form-control-feedback">
                        <span v-for="message in filter('description')" v-bind:key="message">
                            {{message}} <br/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapperx m-portlet__body">
            <div class="m-form__group form-group" v-for="(item, key) in role.roles" v-bind:key="key">
                <label for="">
                    {{$t(key)}}
                </label>
                <div class="m-checkbox-list">
                    <label class="m-checkbox" v-for="(it, k) in item" v-bind:key="k">
                        <input type="checkbox" checked :value="k" v-model="aclList">
                        {{$t(k)}}
                        <span></span>
                    </label>
                </div>
            </div>
        </div>
        <Buttons v-on:save="save" :list-link="`/admin/acl/index`"></Buttons>
    </form>
</template>

<script>
import Buttons from '../../core/form/Buttons'
export default {
  name: 'AclForm',
  components: {Buttons},
  props: {
    role: {
      type: Object,
      required: true
    },
    acls: {
      type: Array,
      required: true
    },
    errors: {
      type: Object
    },
    url: {
      require: true
    }
  },
  data () {
    return {
      aclList: []
    }
  },
  methods: {
    hasError (val) {
      for (let er in this.errors) {
        if (er === val) {
          return true
        }
      }

      return false
    },
    save () {
      this.$store.commit('loading/changeUnsaved', false)
      this.$emit('save')
    },
    filter: function (name) {
      for (let er in this.errors) {
        if (er === name) {
          this.hasDanger = true
          return this.errors[er]
        }
      }

      this.hasDanger = false
      return ''
    }
  },
  watch: {
    aclList: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
        this.$emit('onUpdateAcl', val)
      },
      deep: true
    },
    role: {
      handler (val) {
        this.$store.commit('loading/changeUnsaved', true)
      },
      deep: true
    }
  },
  created: function () {
    this.aclList = this.acls
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/acl/AclForm.vue